import { createElement } from "react";
import Tippy from "@tippyjs/react";
import clsx from "clsx";

export interface Props {
  tooltipText: React.ReactNode;
  children: React.ReactNode;
  tag?: string;
  containerClasses?: string | string[];
  tooltipClasses?: string | string[];
  hideArrow?: boolean;
}

const ToolTip = ({
  tooltipText,
  children,
  tag = "div",
  containerClasses,
  tooltipClasses,
  hideArrow = false,
}: Props) => {
  const Comp = createElement(
    tag,
    {
      className: clsx("inline-block", containerClasses),
      "data-popper-arrow": "",
    },
    children
  );
  return (
    <Tippy
      content={
        <div
          className={clsx(
            tooltipClasses,
            "z-50",
            "bg-gray-200 text-gray-700",
            "rounded px-2 py-1 max-w-sm",
            tooltipClasses
          )}
        >
          {tooltipText}
        </div>
      }
      arrow={!hideArrow}
    >
      {Comp}
    </Tippy>
  );
};

export default ToolTip;
